import useClientGlobalSettings from './client-global-settings-hook';

const useRemoteMissionsEnabled = () => {
  const settingsQuery = useClientGlobalSettings();
  return settingsQuery.isSuccess && settingsQuery.data?.remoteMissionsEnabled === true;
};

export default useRemoteMissionsEnabled;
